import { AxiosServer } from '../../../utils';

export default function findOneOrder(params) {
    let Axios = AxiosServer();
    return Axios.post('/order/findAll', params).then((res) => {
        if(res.data.status === true) {
            return res.data;
        }else {
            throw new Error("失败");
        }
    });
}